import { render, staticRenderFns } from "./individual-shareholders.vue?vue&type=template&id=17218006"
import script from "./individual-shareholders.vue?vue&type=script&lang=js"
export * from "./individual-shareholders.vue?vue&type=script&lang=js"
import style0 from "./individual-shareholders.vue?vue&type=style&index=0&id=17218006&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports